export enum DocumentSearchModeConstants {
  COMPLEX = 'complex',
  SIMPLE = 'simple'
};
